import { Box, Text } from "@chakra-ui/react"

interface SummaryStatCardProps {
  title: string
  value: string
  subline?: string
  titleColor?: string
  valueColor?: string
  sublineColor?: string
  bgColor?: string
  borderColor?: string
}

const SummaryStatCard = ({
  title,
  value,
  subline,
  titleColor = "gray.600",
  valueColor = "gray.900",
  sublineColor,
  bgColor = "white",
  borderColor = "transparent"
}: SummaryStatCardProps) => {
  return (
    <Box
      bg={bgColor}
      p={5}
      borderRadius="lg"
      border="1px solid"
      borderColor={borderColor}
    >
      <Text fontSize="sm" color={titleColor}>
        {title}
      </Text>
      <Text fontSize="3xl" fontWeight="bold" color={valueColor}>
        {value}
      </Text>
      {subline && (
        <Text
          fontSize="xs"
          color={
            sublineColor ??
            (valueColor === "gray.900" ? "gray.600" : valueColor)
          }
        >
          {subline}
        </Text>
      )}
    </Box>
  )
}

export default SummaryStatCard
